if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        // 动态提取属性名
        const optionInputs = document.querySelectorAll('.product-form__input input[type="radio"]');
        const optionNames = Array.from(optionInputs)
          .map(el => el.name.split('-')[0])
          .filter((value, index, self) => self.indexOf(value) === index); 

        const option1Name = optionNames[0] || '';
        const option2Name = optionNames[1] || '';

        // 监听变体变化
        document.querySelectorAll(`input[name^="${option1Name}-1"], input[name^="${option2Name}-2"]`).forEach((radio) => {
          radio.addEventListener('change', () => {
            const selectedOption1 = document.querySelector(`input[name^="${option1Name}-1"]:checked`)?.value?.trim() || '';
            const selectedOption2 = document.querySelector(`input[name^="${option2Name}-2"]:checked`)?.value?.trim() || '';
            const key = selectedOption2 ? `${selectedOption1}|${selectedOption2}` : `${selectedOption1}`;
            this.updateMediaByKey(key);
          });
        });

        // 页面首次加载自动切图
        const defaultOption1 = document.querySelector(`input[name^="${option1Name}-1"]:checked`)?.value?.trim() || '';
        const defaultOption2 = document.querySelector(`input[name^="${option2Name}-2"]:checked`)?.value?.trim() || '';
        const defaultKey = defaultOption2 ? `${defaultOption1}|${defaultOption2}` : `${defaultOption1}`;
        this.updateMediaByKey(defaultKey);

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
        
        // 监听Shopify变体加载完成事件
        document.addEventListener('variant:loaded', () => {
          this.updateMediaForCurrentVariant(option1Name, option2Name);
        });
      }
      
      // 根据当前变体更新媒体
      updateMediaForCurrentVariant(option1Name, option2Name) {
        const selectedOption1 = document.querySelector(`input[name^="${option1Name}-1"]:checked`)?.value?.trim() || '';
        const selectedOption2 = document.querySelector(`input[name^="${option2Name}-2"]:checked`)?.value?.trim() || '';
        const key = selectedOption2 ? `${selectedOption1}|${selectedOption2}` : `${selectedOption1}`;
        this.updateMediaByKey(key);
      }

      updateMediaByKey(key) {
        const allMedia = this.querySelectorAll('[data-media-id]');
        const [option1, option2] = key.split('|');
        const regStrict = new RegExp(`${option1}\\|${option2}`, 'i');
        const regShared = new RegExp(`^${option1}\\|`, 'i');

        let firstMatch = null;
        let hasAlt = false;

        // 检查是否有带 alt 的图片
        allMedia.forEach((media) => {
          const img = media.querySelector('img');
          if (img?.alt?.trim()) {
            hasAlt = true;
          }
        });

        // 判断是否存在严格的“颜色|尺寸” 缩略图
        let hasStrictAlt = false;
        allMedia.forEach((media) => {
          const img = media.querySelector('img');
          const alt = img?.alt?.trim() || '';
          if (regStrict.test(alt)) { 
            hasStrictAlt = true;
          }
        });

        // 处理主图显示逻辑
        allMedia.forEach((media) => {
          const img = media.querySelector('img');
          const alt = img?.alt?.trim() || '';

          if (hasStrictAlt) {
            if (regStrict.test(alt)) {
              media.style.display = '';
              if (!firstMatch && alt.includes('主图')) firstMatch = media;
            } else {
              media.style.display = 'none';
            }
          } else {
            if (regShared.test(alt)) { 
              media.style.display = '';
              if (!firstMatch && alt.includes('主图')) firstMatch = media;
            } else {
              media.style.display = 'none';
            }
          }
        });

        // 无 alt 时显示所有图
        if (!hasAlt) {
          allMedia.forEach((media) => {
            media.style.display = '';
          });
          firstMatch = allMedia[0];
        }

        // 设置默认显示的主图
        if (firstMatch) {
          this.setActiveMedia(firstMatch.dataset.mediaId, false);
        }

        // 处理缩略图显示逻辑
        const allThumbs = this.elements.thumbnails?.querySelectorAll('[data-target]') || [];
        allThumbs.forEach((thumb) => {
          const img = thumb.querySelector('img');
          const alt = img?.alt?.trim() || '';

          if (!hasAlt) {
            thumb.style.display = '';
          } else if (hasStrictAlt) {
            if (regStrict.test(alt)) {
              thumb.style.display = '';
            } else {
              thumb.style.display = 'none';
            }
          } else {
            if (regShared.test(alt)) {
              thumb.style.display = '';
            } else {
              thumb.style.display = 'none';
            }
          }
        });
        
        // 修复：将NodeList转换为数组后再使用filter
        const visibleMediaCount = Array.from(allMedia).filter(
          media => window.getComputedStyle(media).display !== 'none'
        ).length;
        
      //  console.log('当前显示主图数量：', visibleMediaCount);
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${event.detail.currentElement.dataset.mediaId}"]`);
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) || this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) return;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((el) => el.classList.remove('is-active'));
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumb = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumb.parentElement.firstChild !== activeThumb && activeThumb.parentElement.prepend(activeThumb);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const rect = activeMedia.getBoundingClientRect();
          if (rect.top > -0.5) return;
          window.scrollTo({ top: rect.top + window.scrollY, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (this.elements.thumbnails) {
          const activeThumb = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          this.setActiveThumbnail(activeThumb);
          this.announceLiveRegion(activeMedia, activeThumb?.dataset?.mediaPosition);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;
        this.elements.thumbnails.querySelectorAll('button').forEach((btn) => btn.removeAttribute('aria-current'));
        thumbnail.querySelector('button')?.setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (this.stickyHeader) this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

// 全局variantChange事件
window.addEventListener('variantChange', () => {
  const optionInputs = document.querySelectorAll('.product-form__input input[type="radio"]');
  const optionNames = Array.from(optionInputs)
    .map(el => el.name.split('-')[0])
    .filter((value, index, self) => self.indexOf(value) === index);

  const option1Value = document.querySelector(`input[name^="${optionNames[0]}-1"]:checked`)?.value?.trim() || '';
  const option2Value = document.querySelector(`input[name^="${optionNames[1]}-2"]:checked`)?.value?.trim() || '';

  if (!option1Value) return;

  const key = option2Value ? `${option1Value}|${option2Value}` : `${option1Value}`;
  const gallery = document.querySelector('media-gallery');
  
  setTimeout(() => {
    gallery?.updateMediaByKey?.(key);
  }, 200);
});

// 防抖函数
function debounce(func, wait) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}